'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { createElement } from '@emotion/react';
import { Group } from '@s7/layout';
import { Link } from '@s7/ui';
import { useLinkOverride } from '../../../common/ResourceLink/LinkOverride.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultSecondaryLinkProps = {
    underline: "hover",
    color: "text.secondary",
    size: "xs2"
};
var FooterSecondaryLinks = function(props) {
    var items = props.items, linkProps = props.linkProps, onItemClick = props.onItemClick, others = _object_without_properties_loose(props, [
        "items",
        "linkProps",
        "onItemClick"
    ]);
    var unpackLink = useLinkOverride();
    return /*#__PURE__*/ jsx(Group, _extends({
        breakpoints: {
            "sm1.up": {
                spacing: 20
            }
        },
        spacing: 12
    }, others, {
        children: items.map(function(item) {
            return /*#__PURE__*/ createElement(Link, _extends({}, defaultSecondaryLinkProps, linkProps, {
                key: item.id
            }, unpackLink(item.link), {
                onClick: function(event) {
                    onItemClick == null ? void 0 : onItemClick(item, event);
                }
            }), item.title);
        })
    }));
};

export { FooterSecondaryLinks };
